import FieldProgress from "../../../generic/progress/progress";
import FieldConfig from "../../../proto/field-config";
import ItemModel from "../../../../model2/item/item-model";
import Project from "../../../../model2/project/project";


export default class FieldProjectProgress extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project progress";
        this.label      = _.get(config, 'label', "Project progress")

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeProgress
    }


    tableCellOnValueChange = async (item:ItemModel, value: number | null) => {

        item.project.progress = value ? value : null

        item.project.save()
    }
}